import { useCallback, useEffect, useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "../../redux-store";
import EventBannerPlaceholder from "../../assets/images/event-image-placeholder.jpeg";
import { useCurrentMerchantId } from "hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    profileCard: {
      padding: "1% 1% 1% 2%",
      [theme.breakpoints.down("sm")]: {
        padding: "1%",
      },
    },
  }),
);

const useProfileDetail = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  const dispatch = useDispatch();

  const merchantId = useCurrentMerchantId();

  const merchant = useSelector(selectors.getMerchantsList).find(
    (merch) => merch._id === merchantId,
  );

  const isBanner = useSelector(selectors.getMerchantsList).find((merch) => {
    if (merch._id === merchantId) {
      return merch.imageUri === EventBannerPlaceholder;
    } else return false;
  });
  useEffect(() => {
    dispatch(actions.getMerchants.request({ merchantId }));
  }, [dispatch, merchantId]);

  return {
    styles,
    classes,
    atomicStyles,
    merchant,
    isBanner,
  };
};

export { useProfileDetail as default };
